import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en/en.json';
import es from './locales/es/es.json';
const language = localStorage.getItem('language');
import translationEn from 'zod-i18n-map/locales/en/zod.json';
import translationEs from 'zod-i18n-map/locales/es/zod.json';
import { z } from 'zod';
import { makeZodI18nMap } from 'zod-i18n-map';

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: 'en',
    ...(language && { lng: language }),
    resources: {
      en: {
        translation: {
          ...en,
        },
        zod: translationEn,
      },
      es: {
        translation: {
          ...es,
        },
        zod: translationEs,
      },
    },
  });

z.setErrorMap(
  makeZodI18nMap({
    ns: ['zod', 'form'],
    handlePath: {
      keyPrefix: 'paths',
    },
  })
);
